import { getFeatureToggleClient } from '../../infra/featureToggles'

export function isInventorySupportingItemsEnabled(): boolean {
  return getFeatureToggleClient().variation(
    'WorkPortal.InventoryItemSupportingItems'
  )
}
